import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class Uploader {
  constructor() {
    _defineProperty(this, "callbacks", {
      success: [],
      failure: [],
      uploading: [],
      uploaded: []
    });
    _defineProperty(this, "uploading", false);
    _defineProperty(this, "fileState", void 0);
  }
  setState(fileState) {
    this.fileState = fileState;
  }
  on(type, callback) {
    this.callbacks[type].push(callback);
  }
  dispatch(type, response) {
    this.callbacks[type].forEach(callback => callback(response));
  }
  upload(files, addBBcode) {
    if (addBBcode === void 0) {
      addBBcode = true;
    }
    this.uploading = true;
    this.dispatch('uploading', files);
    m.redraw();
    const body = new FormData();
    const fileArray = Array.from(files);
    for (let i = 0; i < fileArray.length; i++) {
      body.append('files[]', fileArray[i]);
    }
    return app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/fof/upload',
      serialize: raw => raw,
      body
    }).then(result => this.uploaded(result, addBBcode)).catch(error => {
      var _error$response, _e$code;
      this.uploading = false;
      m.redraw();
      const e = (_error$response = error.response) == null || (_error$response = _error$response.errors) == null ? void 0 : _error$response[0];
      if (!(e != null && (_e$code = e.code) != null && _e$code.includes('fof-upload'))) {
        throw error;
      }
      app.alerts.clear();
      app.alerts.show({
        type: 'error'
      }, e.detail);
    });
  }
  uploaded(result, addBBcode) {
    if (addBBcode === void 0) {
      addBBcode = false;
    }
    this.uploading = false;
    result.data.forEach(file => {
      var _this$fileState;
      const fileObj = app.store.pushObject(file);
      (_this$fileState = this.fileState) == null || _this$fileState.addToList(fileObj);
      this.dispatch('success', {
        file: fileObj,
        addBBcode
      });
    });
    this.dispatch('uploaded');
  }
}
flarum.reg.add('fof-upload', 'forum/handler/Uploader', Uploader);